import moment from 'moment';
import { Grid, Box } from '@mui/material';
import { Table, TableRow, TableBody } from '@mui/material';
import { convertToStoreLocalTime } from '@/common/utils/time';
import { OverviewStyles, OverviewTableCell, OverviewCard } from '../Info';

const AvailableCredits = props => {
  const { customerData, changeTab } = props;
  const classes = OverviewStyles();

  return (
    <OverviewCard>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box p={1}>
            <button
              className={classes.headingButton}
              onClick={() => changeTab('account')}
            >
              Available Credits
            </button>
            <Table className={classes.noBorder}>
              <TableBody>
                <TableRow>
                  <OverviewTableCell>
                    <span style={{ fontWeight: 'bold' }}>Amount</span>
                  </OverviewTableCell>
                  <OverviewTableCell>
                    <span style={{ fontWeight: 'bold' }}>Credit Types</span>
                  </OverviewTableCell>
                  <OverviewTableCell>
                    <span style={{ fontWeight: 'bold' }}>Source</span>
                  </OverviewTableCell>
                  <OverviewTableCell>
                    <span style={{ fontWeight: 'bold' }}>Studio</span>
                  </OverviewTableCell>
                  <OverviewTableCell>
                    <span style={{ fontWeight: 'bold' }}>Expiration</span>
                  </OverviewTableCell>
                </TableRow>
                {customerData?.creditGroups &&
                customerData?.creditGroups.length > 0 ? (
                  customerData?.creditGroups?.map((creditGroup, index) => (
                    <TableRow
                      key={index}
                      style={{
                        color: creditGroup.isFrozen ? 'gray' : 'inherit'
                      }}
                    >
                      <OverviewTableCell style={{ color: 'inherit' }}>
                        {creditGroup.amount}
                        {creditGroup.isFrozen ? ' (Frozen)' : ''}
                      </OverviewTableCell>
                      <OverviewTableCell style={{ color: 'inherit' }}>
                        {creditGroup.type}
                      </OverviewTableCell>
                      <OverviewTableCell style={{ color: 'inherit' }}>
                        {creditGroup.source}
                      </OverviewTableCell>
                      <OverviewTableCell style={{ color: 'inherit' }}>
                        {creditGroup.storeCode}
                      </OverviewTableCell>
                      <OverviewTableCell
                        style={{
                          color:
                            moment(
                              convertToStoreLocalTime(creditGroup.expires)
                            ).diff(moment(), 'days') < 7
                              ? 'red'
                              : 'inherit'
                        }}
                      >
                        {moment(
                          convertToStoreLocalTime(creditGroup.expires)
                        ).format('MM/DD/YYYY')}
                      </OverviewTableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <OverviewTableCell>--</OverviewTableCell>
                    <OverviewTableCell>--</OverviewTableCell>
                    <OverviewTableCell>--</OverviewTableCell>
                    <OverviewTableCell>--</OverviewTableCell>
                    <OverviewTableCell>--</OverviewTableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default AvailableCredits;
